import { useQuery } from '@tanstack/react-query';

import requestGetMessageArchives, {
  type MessageArchivesResponse,
} from '~/queries/customerCommunication/requestGetMessageArchives';

import requestGetMessageArchiveRenderedHtml from '~/queries/customerCommunication/requestGetMessageArchiveRenderedHtml';

export const messageArchivesQueryKeys = {
  all: ['messageArchives'] as const,
  lists: () => [...messageArchivesQueryKeys.all, 'list'] as const,
  list: (userId: string, offset: number, limit: number) =>
    [...messageArchivesQueryKeys.lists(), userId, offset, limit] as const,
  renderedHtml: (id: string) => [...messageArchivesQueryKeys.all, 'renderedHtml', id] as const,
};

export function useGetMessageArchives(userId: string, offset: number, limit: number) {
  return useQuery<MessageArchivesResponse>({
    queryKey: messageArchivesQueryKeys.list(userId, offset, limit),
    queryFn: ({ signal }) => requestGetMessageArchives(userId, offset, limit, signal),
    enabled: !!userId,
  });
}

export function useGetMessageArchiveRenderedHtml(id: string) {
    return useQuery<string>({
      queryKey: messageArchivesQueryKeys.renderedHtml(id),
      queryFn: () => requestGetMessageArchiveRenderedHtml(id),
      enabled: !!id,
    });
  }
